module.exports = __webpack_public_path__ + "img/calculator.b555744f.png";